(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-ic-configurator]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const form = root.querySelector('form');
      const picker = root.querySelector('[data-ic-files]');
      const list = root.querySelector('[data-ic-file-list]');
      const fields = root.querySelector('[data-ic-file-fields]');
      const error = root.querySelector('[data-ic-file-error]');
      const copy = JSON.parse(root.querySelector('[data-ic-copy]').textContent);
      const submit = form.querySelector('[type="submit"]');
      let adding = false;
      let files = [];
      let objectUrls = [];
      const supported = typeof DataTransfer === 'function';
      if (!supported) {
        error.textContent = copy.unsupported;
        error.hidden = false;
        return;
      }
      const variants = JSON.parse(root.querySelector('[data-ic-variants]').textContent);
      const variantInput = form.querySelector('[data-ic-variant-id]');
      const formError = root.querySelector('[data-ic-form-error]');
      const updateVariant = () => {
        const view = form.querySelector('input[name="ic_view"]:checked');
        const size = form.querySelector('input[name="ic_size"]:checked');
        const variant = variants.find(item => item.view === view?.value && item.size === size?.value);
        const base = variants.find(item => item.view === view?.value && item.size === 'A4 Standard');
        variantInput.value = variant?.id || '';
        form.querySelector('[data-ic-view-property]').value = view?.value || '';
        form.querySelector('[data-ic-size-property]').value = size?.value || '';
        const formatted = variant?.formatted || base?.formatted || '';
        form.querySelector('[data-ic-button-price]').textContent = formatted;
        document.querySelectorAll('[data-custom-price]').forEach(price => price.textContent = formatted);
        form.querySelectorAll('[data-ic-size-price]').forEach(label => {
          const option = variants.find(item => item.view === view?.value && item.size === label.dataset.icSizePrice);
          if (option) label.textContent = '+' + option.uplift;
        });
        submit.disabled = adding || (size ? !variant?.available : !base?.available);
        formError.hidden = true;
      };
      updateVariant();
      const setError = message => {
        error.textContent = message;
        error.hidden = !message;
        picker.setCustomValidity(message);
      };
      const validate = () => {
        if (files.length < 2) return copy.min;
        if (files.length > 6) return copy.max;
        if (files.some(file => !['image/jpeg', 'image/png', 'image/webp'].includes(file.type))) return copy.type;
        if (files.some(file => file.size > 10 * 1024 * 1024)) return copy.size;
        if (files.reduce((sum, file) => sum + file.size, 0) > 20 * 1024 * 1024) return copy.total;
        return '';
      };
      const render = () => {
        objectUrls.forEach(url => URL.revokeObjectURL(url));
        objectUrls = [];
        list.replaceChildren();
        fields.replaceChildren();
        const combined = new DataTransfer();
        files.forEach((file, index) => {
          combined.items.add(file);
          const transfer = new DataTransfer();
          transfer.items.add(file);
          const field = document.createElement('input');
          field.type = 'file';
          field.name = 'properties[Foto ' + (index + 1) + ']';
          field.files = transfer.files;
          fields.append(field);
          const card = document.createElement('div');
          card.className = 'ic-photo';
          const thumb = document.createElement('img');
          const url = URL.createObjectURL(file);
          objectUrls.push(url);
          thumb.src = url;
          thumb.alt = '';
          const name = document.createElement('span');
          name.textContent = (index + 1) + '. ' + file.name;
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.textContent = '×';
          remove.setAttribute('aria-label', copy.remove + ': ' + file.name);
          remove.addEventListener('click', () => {
            files.splice(index, 1);
            render();
            setError(validate());
          });
          card.append(thumb, name, remove);
          list.append(card);
        });
        picker.files = combined.files;
      };
      picker.addEventListener('change', () => {
        const incoming = Array.from(picker.files);
        const unique = new Map(files.map(file => [file.name + ':' + file.size + ':' + file.lastModified, file]));
        incoming.forEach(file => unique.set(file.name + ':' + file.size + ':' + file.lastModified, file));
        files = Array.from(unique.values());
        render();
        setError(validate());
      });
      form.querySelectorAll('input[name="ic_view"]').forEach(input => input.addEventListener('change', () => {
        if (!input.checked) return;
        updateVariant();
        document.querySelector('[data-ic-gallery]')?.dispatchEvent(new CustomEvent('ic:select', { detail: Number(input.dataset.galleryIndex) }));
      }));
      form.querySelectorAll('input[name="ic_size"]').forEach(input => input.addEventListener('change', () => {
        if (!input.checked) return;
        updateVariant();
        document.querySelector('[data-ic-gallery]')?.dispatchEvent(new CustomEvent('ic:select', { detail: { index: Number(input.dataset.galleryIndex), scroll: true } }));
      }));
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (adding) return;
        if (!variantInput.value) {
          event.preventDefault();
          formError.textContent = copy.chooseSize;
          formError.hidden = false;
          return;
        }
        const message = validate();
        setError(message);
        if (message || !form.reportValidity()) {
          event.preventDefault();
          picker.focus();
          return;
        }
        form.querySelector('[data-ic-view-property]').value = form.querySelector('input[name="ic_view"]:checked').value;
        // Keep the multipart body intact: Shopify stores the actual uploaded photos.
        const body = new FormData(form);
        const drawer = document.querySelector('cart-drawer');
        const sections = drawer?.getSectionsToRender().map(section => section.id) || [];
        if (sections.length) {
          body.set('sections', sections.join(','));
          body.set('sections_url', window.location.pathname);
          drawer.setActiveElement(submit);
        }
        const label = submit.querySelector('span');
        const originalLabel = label.textContent;
        adding = true;
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        label.textContent = copy.adding;
        formError.hidden = true;
        let added = false;
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || copy.addError);
          added = true;
          if (!drawer) {
            window.location.assign(window.routes?.cart_url || '/cart');
            return;
          }
          // A section rendering failure must never repeat the successful add request.
          if (sections.some(id => !data.sections?.[id])) {
            const url = new URL(window.location.href);
            url.searchParams.set('sections', sections.join(','));
            const refresh = await fetch(url, { credentials: 'same-origin' });
            if (!refresh.ok) throw new Error(copy.addError);
            data.sections = await refresh.json();
          }
          if (sections.some(id => !data.sections?.[id])) throw new Error(copy.addError);
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ic-configurator', productVariantId: body.get('id'), cartData: data });
          }
        } catch (failure) {
          if (added) {
            window.location.assign(window.routes?.cart_url || '/cart');
            return;
          }
          formError.textContent = failure.message || copy.addError;
          formError.hidden = false;
        } finally {
          adding = false;
          submit.removeAttribute('aria-busy');
          label.textContent = originalLabel;
          const selected = variants.find(item => String(item.id) === variantInput.value);
          submit.disabled = !selected?.available;
        }
      });
    });
    scope.querySelectorAll('[data-ic-gallery]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const track = root.querySelector('[data-ic-track]');
      const slides = Array.from(root.querySelectorAll('[data-ic-slide]'));
      const buttons = Array.from(root.querySelectorAll('[data-ic-thumb]'));
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const show = index => {
        track.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
      };
      buttons.forEach((button, index) => button.addEventListener('click', () => show(index)));
      root.addEventListener('ic:select', event => {
        const detail = event.detail;
        show(typeof detail === 'number' ? detail : detail.index);
        if (typeof detail === 'object' && detail.scroll) {
          const headerHeight = document.querySelector('.section-header')?.offsetHeight || 0;
          window.scrollTo({ top: Math.max(0, root.getBoundingClientRect().top + window.scrollY - headerHeight - 12), behavior: reduced ? 'auto' : 'smooth' });
        }
      });
      let tick;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(tick);
        tick = requestAnimationFrame(() => {
          const index = slides.reduce((best, slide, i) => Math.abs(slide.offsetLeft - slides[0].offsetLeft - track.scrollLeft) < Math.abs(slides[best].offsetLeft - slides[0].offsetLeft - track.scrollLeft) ? i : best, 0);
          buttons.forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
          root.querySelector('[data-ic-counter]').textContent = (index + 1) + ' / ' + slides.length;
        });
      }, { passive: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
